import { createAction } from "redux-actions";
import { AuditLogConstants } from "./auditLogConstants";

export const fetchAuditLog = createAction(AuditLogConstants.FETCH_AUDIT_LOG);
